export function consolidationRowId(row = {}) {
  return row.consolidation_id || row.id || '';
}

export function normalizeConsolidationLines(raw) {
  if (Array.isArray(raw)) return raw;
  if (!raw || typeof raw !== 'object') return [];
  return raw.lines
    ?? raw.consolidation_lines
    ?? raw.items
    ?? raw.data
    ?? [];
}

export function normalizeConsolidation(raw = {}) {
  const lines = normalizeConsolidationLines(raw.lines ?? raw.consolidation_lines ?? raw.items);
  return {
    ...raw,
    id: consolidationRowId(raw),
    lines,
    status: raw.status || 'CONSOLIDATED',
    purchase_order_id: raw.purchase_order_id || raw.po_id || null,
  };
}
